// All prices CAD.
export const VEHICLES = [
  { id: "sedan", label: "Sedan" },
  { id: "suv", label: "SUV" },
  { id: "van", label: "Van / Truck" },
];

export const ONE_TIME = {
  interior: { sedan: 129, suv: 149, van: 169 },
  full: { sedan: 169, suv: 189, van: 199 },
  express: 75,
};

export const DETAIL_TYPES = [
  { id: "full", label: "Full Detail", note: "Interior + Exterior" },
  { id: "interior", label: "Interior Only", note: "Deep interior clean" },
];

// Recurring visit discount off the one-time price.
export const PLANS = [
  { id: "seasonal", name: "Seasonal", freq: "4× per year", off: 0.05, badge: null },
  { id: "monthly", name: "Monthly", freq: "Every month", off: 0.15, badge: null },
  { id: "biweekly", name: "Bi-Weekly", freq: "Every 2 weeks", off: 0.20, badge: "Most Popular" },
  { id: "weekly", name: "Weekly", freq: "Every week", off: 0.25, badge: null },
  { id: "vip", name: "Annual VIP", freq: "12 prepaid details + priority booking", off: 0.30, badge: null, annual: true },
];

export const CERAMIC = [
  { id: "shine", name: "Shine & Seal", price: 249, protection: "1-Year Sealant", desc: "A brilliant hydrophobic seal that keeps your paint slick and glossy through a full season." },
  { id: "pro", name: "Pro Coat", price: 899, protection: "3-Year Coating", desc: "Semi-permanent 9H protection with serious depth of gloss — our most requested coating.", popular: true },
  { id: "elite", name: "Elite Coat", price: 1299, protection: "5-Year Coating", desc: "The ultimate armor. Multi-layer ceramic for years of showroom shine and effortless washing." },
];

export const WAYS_TO_SAVE = [
  { title: "Summer Special", desc: "10% off — auto-applied at checkout today.", accent: true },
  { title: "Multi-Vehicle", desc: "10% off your 2nd vehicle, 15% off each additional. $10 flat off extra Express services." },
  { title: "Family Fleet", desc: "2+ cars on any subscription = an extra 5% off both cars, every visit." },
  { title: "Loyalty Reward", desc: "Every 6th detail is 50% off. It pays to stay fresh." },
  { title: "Refer a Friend", desc: "Give $20, get $20 — credit for both of you." },
];

export const FAQ = [
  {
    q: "How much does car detailing cost in Ottawa?",
    a: "A one-time detail with Reverence starts at $75 + tax for our Express 90-Min Refresh, with Full Details from $169 + tax and Interior details from $129 + tax (priced by vehicle size). Subscriptions lower the per-visit price by up to 30%.",
  },
  {
    q: "What's included in a full detail?",
    a: "A full detail covers a complete interior deep clean plus a hand exterior wash, decontamination and protection. It's the inside-and-out reset that makes your car feel brand new.",
  },
  {
    q: "How long does a detail take?",
    a: "Our Express refresh is done in about 90 minutes, while a full detail takes roughly 3–4 hours. Ceramic coatings run 1–2 days depending on the package.",
  },
  {
    q: "Is mobile detailing more expensive?",
    a: "No — we come to you at no extra charge. You get the same premium results without the drive, the drop-off, or a wasted Saturday.",
  },
  {
    q: "How much is ceramic coating in Ottawa?",
    a: "Ceramic packages start at $249 for our 1-year Shine & Seal and go up to $1,299 for the 5-year Elite Coat. Add $100 for vans and trucks due to the larger surface area.",
  },
  {
    q: "Can I cancel my subscription anytime?",
    a: "Absolutely — there are no contracts and no cancellation fees. Pause, change your plan, or cancel whenever life changes.",
  },
];

export const planPrice = (base, off) => Math.round(base * (1 - off));
